module.exports = __webpack_public_path__ + "img/sq_record_img2.baab379d.png";